/**
 * User Types - Shared types for user management
 */

export interface User {
  id: number;
  username: string;
  first_name?: string;
  last_name?: string;
  email: string;
  role: string;
  cpf?: string;
  hospital_id?: number;
  hospital_nome?: string;
  telefone?: string;
  ativo: boolean;
  receber_email?: boolean;
  /** N116: e-mail sempre presente na lista de destinatários do app offline.
   *  Campo distinto de `receber_email` de propósito — ver models/user.py. */
  incluir_email_offline?: boolean;
  cliente_ids?: number[];
  // SMTP fields
  smtp_email?: string;
  smtp_servidor?: string;
  smtp_porta?: number;
  smtp_tls?: boolean;
  has_smtp_password?: boolean;
  // For editing
  newPassword?: string;
  confirmPassword?: string;
}

export interface UserFilters {
  search?: string;
  roles?: string[];
  status?: string[];
  cliente_ids?: number[];
}

export interface NewUserData {
  username: string;
  full_name: string;
  email: string;
  password: string;
  confirmPassword: string;
  role: string;
  telefone: string;
  receber_email: boolean;
  incluir_email_offline: boolean; // N116
  smtp_email: string;
  smtp_senha: string;
  smtp_servidor: string;
  smtp_porta: number;
  smtp_tls: boolean;
}

export const getInitialNewUser = (): NewUserData => ({
  username: '',
  full_name: '',
  email: '',
  password: '',
  confirmPassword: '',
  role: 'ANALISTA',
  telefone: '',
  receber_email: true,
  // N116: nasce DESLIGADO. Marcar isto faz o e-mail entrar em envios que vão
  // para hospital e cliente — tem de ser escolha explícita, não default.
  incluir_email_offline: false,
  smtp_email: '',
  smtp_senha: '',
  smtp_servidor: 'smtp.gmail.com',
  smtp_porta: 587,
  smtp_tls: true,
});

/**
 * Get user display name from User object
 */
export const getUserDisplayName = (user: User): string => {
  if (user.username) {
    return user.username;
  }
  if (user.email) {
    return user.email;
  }
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  if (user.first_name) {
    return user.first_name;
  }
  return 'Sem nome';
};

/**
 * Get user full name (first_name + last_name), fallback to username
 */
export const getUserFullName = (user: User): string => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  if (user.first_name) {
    return user.first_name;
  }
  return user.username || 'Sem nome';
};
